import { type ContentItem, type NFTContent } from './yat-page-actions';

export const ACTION_SET_MANAGER_PANEL_OPEN = 'ACTION_SET_MANAGER_PANEL_OPEN';
export const ACTION_SET_MANAGER_PANEL_CLOSED = 'ACTION_SET_MANAGER_PANEL_CLOSED';
export const ACTION_TOGGLE_MANAGER_PANEL_MINIFIED = 'ACTION_TOGGLE_MANAGER_PANEL_MINIFIED';
export const ACTION_SET_MANAGER_START_DRAGGING_NFT = 'ACTION_SET_MANAGER_START_DRAGGING_NFT';
export const ACTION_SET_MANAGER_STOP_DRAGGING_NFT = 'ACTION_SET_MANAGER_STOP_DRAGGING_NFT';
export const ACTION_SELECT_ALL_MANAGER_ITEMS = 'ACTION_SELECT_ALL_MANAGER_ITEMS';
export const ACTION_SELECT_MANAGER_ITEMS = 'ACTION_SELECT_MANAGER_ITEMS';
export const ACTION_CLEAR_MANAGER_SELECTION = 'ACTION_CLEAR_MANAGER_SELECTION';
export const ACTION_UPDATE_MANAGER_NFT_FILTERS = 'ACTION_UPDATE_MANAGER_NFT_FILTERS';
export const ACTION_PREVIEW = 'ACTION_PREVIEW';
export const ACTION_SET_MANAGER_SEARCH_VALUE = 'ACTION_SET_MANAGER_SEARCH_VALUE';
export const ACTION_SET_MANAGER_CURRENT_MOUSE_POSITION = 'ACTION_SET_MANAGER_CURRENT_MOUSE_POSITION';
export const ACTION_DISPLAY_SNACKBAR = 'ACTION_DISPLAY_SNACKBAR';
export const ACTION_SET_UNSUPPORTED_NFTS = 'ACTION_SET_UNSUPPORTED_NFTS';
export const ACTION_ADD_UNSUPPORTED_NFT = 'ACTION_ADD_UNSUPPORTED_NFT';

export interface NFTManagerFilter {
    sortingOrder?: NFTManagerSortOrder;
    sortingField?: NFTManagerSortField;
    ownerAddress?: string[];
    floorPriceCurrency?: Currency;
    /** min */
    floorPriceGe?: number;
    /** max */
    floorPriceLe?: number;
    name?: string;
    collection?: string;
    spam?: boolean;
    unsupported?: boolean;
}

export type NFTManagerSortOrder = 'Asc' | 'Desc';
export type NFTManagerSortField = 'activity_date' | 'floor_price' | 'gains' | 'purchase_date' | 'timescore';

export type Currency = 'eth';

export type NFTItem = ContentItem<NFTContent>;

interface ManagerQueryData {
    total?: number;
    filters?: NFTManagerFilter;
    hasNext?: boolean;
    loading?: boolean;
    offset?: number;
    limit?: number;
    page?: number;
}

export interface NFTManagerState {
    managerPanelOpen: boolean;
    unsupportedNfts?: string[];
    managerPanelCollapsed: boolean;
    selectedItems: string[];
    draggingItems: string[];
    draggingInitialMouseEvent: MouseEvent | null;
    draggingCurrentMousePosition: { x: number; y: number } | null;
    managerSearchValue: string;
    managerFilters: NFTManagerFilter;
    managerQueryData: ManagerQueryData;
    displaySnackbar: boolean;
    selectInPageItems: boolean;
    selectedAllItems: boolean;
}

interface setNFTManagerPanelOpen {
    type: typeof ACTION_SET_MANAGER_PANEL_OPEN;
}

interface setNFTManagerPanelClose {
    type: typeof ACTION_SET_MANAGER_PANEL_CLOSED;
}

interface toggleNFTManagerMinified {
    type: typeof ACTION_TOGGLE_MANAGER_PANEL_MINIFIED;
    collapsed?: boolean;
}

interface setStartDraggingNFT {
    type: typeof ACTION_SET_MANAGER_START_DRAGGING_NFT;
    mouseEvent: MouseEvent;
    item: string;
}

interface setCurrentDraggingMousePosition {
    type: typeof ACTION_SET_MANAGER_CURRENT_MOUSE_POSITION;
    currentMousePosition: { x: number; y: number };
}

interface setStopDraggingNFT {
    type: typeof ACTION_SET_MANAGER_STOP_DRAGGING_NFT;
}

interface selectManagerItem {
    type: typeof ACTION_SELECT_MANAGER_ITEMS;
    items: string | string[];
    inPage: boolean;
}

interface clearManagerSelection {
    type: typeof ACTION_CLEAR_MANAGER_SELECTION;
}

interface setNFTManagerSearchValue {
    type: typeof ACTION_SET_MANAGER_SEARCH_VALUE;
    managerSearchValue: string;
}

interface updateNFTManagerFilters {
    type: typeof ACTION_UPDATE_MANAGER_NFT_FILTERS;
    filter?: NFTManagerFilter;
    clear: boolean;
}

interface managerPreview {
    type: typeof ACTION_PREVIEW;
}

interface toggleDisplaySnackBar {
    type: typeof ACTION_DISPLAY_SNACKBAR;
    direction: boolean;
}

interface setUnsupportedNfts {
    type: typeof ACTION_SET_UNSUPPORTED_NFTS;
    unsupportedNfts: string[];
}

interface addUnsupportedNft {
    type: typeof ACTION_ADD_UNSUPPORTED_NFT;
    unsupportedNft: string;
}

interface selectAllManagerItems {
    type: typeof ACTION_SELECT_ALL_MANAGER_ITEMS;
}

export type NFTManagerActions =
    | setNFTManagerPanelOpen
    | setNFTManagerPanelClose
    | toggleNFTManagerMinified
    | setStartDraggingNFT
    | setCurrentDraggingMousePosition
    | selectManagerItem
    | clearManagerSelection
    | setStopDraggingNFT
    | updateNFTManagerFilters
    | managerPreview
    | setNFTManagerSearchValue
    | setUnsupportedNfts
    | addUnsupportedNft
    | toggleDisplaySnackBar
    | selectAllManagerItems;
